import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { InputYear } from "../Components/Inputs/Input_Year.jsx";
import { errorCheckForm, errorClear, errorJsonHasErrors, errorSet, errorSetPlus } from "../Components/Inputs/Input_Fns.jsx";

import { get, set } from "lodash";

import ValueInflatable from "./ValueInflatable.jsx";
import {
  CleanAvail,
  ftchPlus,
  getOptions,
  putOptions,
  SavingRuleUrl_get,
  SavingRuleUrl_put,
} from "./Account_urls.jsx";
import {
  CollapseAddLabel,
  CollapseDelete,
  Down,
  Up,
} from "./CollapseButtons.jsx";
import { AddDialog } from "../Components/AddDialog.jsx";
import { InputPercentage } from "../Components/Inputs/Input_Percentage.jsx";
import { InputAccountTypeName } from "../Components/Inputs/Account_TypeName.jsx";
import { InputSelect1, InputSelectN } from "../Components/Inputs/Select.jsx";
import { Arrayify } from "../Functions/utils.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSlash } from "@fortawesome/free-solid-svg-icons";
import { SavingRuleText } from "../Functions/savingRuleText.jsx";
import { InputCheck } from "../Components/Inputs/Input_Check.jsx";
import { myOwnFPColor } from "./GridRenderers.jsx";



export const CombinedAccountNameList = (who, avail, availSpouse, label) => {
  //console.log(label)
  let n_a = []
  let t_a = []
  //console.log(form.Who)
  if (who.includes("Personal") && avail && avail[label] !== undefined && avail[label] !== null) {
    n_a = Arrayify(avail[label].AccountNames)
    t_a = Arrayify(avail[label].AccountTypes)
    //console.log(n_a)
  }
  let n_b = []
  let t_b = []
  if (who.includes("Spousal") && availSpouse && availSpouse[label] !== undefined && availSpouse[label] !== null) {
    n_b = Arrayify(availSpouse[label].AccountNames)
    t_b = Arrayify(availSpouse[label].AccountTypes)
    //console.log(n_b)
  }
  let n = new Set(n_a.concat(n_b))
  let t = new Set(t_a.concat(t_b))


  let res = {
    AccountNames: Array.from(n),
    AccountTypes: Array.from(t)
  }
  //console.log(res)

  return res
}



var inf_value = {
  Value: 0,
  Year: new Date().getFullYear() - 1,
  Threshold: 0,
  Type: "Yearly",
  Rate: 0,
};

var from = {
  Id: 0,
  AccountType: "",
  AccountName: "",
  Who: ["Personal"],
};

var to = {
  Id: 0,
  Account: {
    Id: 0,
    AccountType: "",
    AccountName: "",
    Who: ["Personal"],
  },
  EmploymentAccount: "",
  Method: "",
  Value: inf_value,
  Percent: 0,
  Min: inf_value,
  Max: inf_value,
  SpousalKeepBalanced: false,
  FromMin: inf_value,
  ToMax: inf_value,
  TextRule: "Empty",
  Changed: true,
};

const ToAccount = ({
  avail,
  availSpouse,
  form,
  onChange,
  accountType,
  accountTypeSpecific,
  doValidation,
  onError
}) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    console.log("VY:change");
    console.log(form);
    console.log(n);
    console.log(v);
    let nf = structuredClone(form);
    nf[n] = v;
    //nf.Changed = true;
    console.log(nf);
    onChange(nf);
    return nf
  };



  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };
  const onChange_select = (e) => {
    let nf = onChange_any(e.target.name, e.target.value);
    // here we validate on the nf since form isn't updated yet
    validate(nf)
  }
  const onChange_c = (e) => {
    onChange_any(e.target.name, e.target.checked);
  };

  const onChangeValue = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      [name]: value,
      // "Changed": true,
    };
    onChange(nf);
  };
  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }
  const validate = (f) => {
    let ne = structuredClone(errors)

    let err = (f.Method === "") ? "Please set a method" : ""
    ne = set(ne, "Method", err)

    err = (f.Method === "PercentOfEmployment" && f.EmploymentAccount === "") ? "Please enter an Account" : ""
    ne = set(ne, "EmploymentAccount", err)

    console.log(ne)
    setErrors(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }

  }


  useEffect(() => {
    // here we validate on the form
    validate(form)
  }, [doValidation])


  return (
    <Container maxWidth="true">
      {/* <Container> */}
      <Box sx={{ m: 1, p: 2, border: "1px solid grey" }}>
        <Stack direction="row" spacing={2}>
          <Stack spacing={2}>
            <FromAccount
              avail={avail}
              availSpouse={availSpouse}
              form={form.Account}
              direction="column"
              label="To"
              onChange={(e) => onChange_any("Account", e)}
              accountType={accountType}
              accountTypeSpecific={form.Type}
              onError={(e) => myError("fromaccount", null, e)}
              doValidation={doValidation}
            />
          </Stack>
          <Divider orientation="vertical" flexItem />

          <Stack spacing={2}>
            <InputSelect1
              label="Method"
              name="Method"
              value={form.Method}
              onChange={onChange_select}
              errors={errors}
              avail={avail.Methods}
            />
            <InputSelect1
              label="Employment Account"
              name="EmploymentAccount"
              value={form.EmploymentAccount}
              onChange={onChange_select}
              errors={errors}
              avail={avail.EmploymentAccountNames}
              disabled={!form.Method.includes("Employment")}
            />
            <ValueInflatable
              form={form.Value}
              label="Save"
              onChange={onChangeValue}
              avail={avail}
              name="Value"
              color="delete"
              showInf={false}
              disabled={
                !(
                  form.Method.includes("Reduce") ||
                  form.Method.includes("Value")
                )
              }
              onError={(e) => myError("valueI", null, e)}

            />
            <InputPercentage
              label="Percent"
              name="Percent"
              disabled={!form.Method.includes("Percent")}
              percent={form.Percent}
              onChange={onChange_t}
              maxPct={form.Method === "PercentOfYearlyLimit" ? 500 : 100}
              onError={(e) => myError("percent", null, e)}

            />
          </Stack>
          <Divider orientation="vertical" flexItem />

          <Stack spacing={2}>
            <Stack>
              <Typography sx={{ mt: -2 }} id="s-die-age-slider" variant="h6" gutterBottom>
                Limits
              </Typography>
            </Stack>
            <ValueInflatable
              form={form.Min}
              label="Min"
              onChange={onChangeValue}
              avail={avail}
              name="Min"
              color="delete"
              showInf={false}
              onError={(e) => myError("min", null, e)}

            />
            <ValueInflatable
              form={form.Max}
              label="Max"
              onChange={onChangeValue}
              avail={avail}
              name="Max"
              color="delete"
              showInf={false}
              onError={(e) => myError("max", null, e)}

            />
          </Stack>
          <Divider orientation="vertical" flexItem />

          <Stack spacing={2}>
            <Stack>
              <Typography sx={{ mt: -2 }} id="s-die-age-slider" variant="h6" gutterBottom>
                Constraints
              </Typography>
            </Stack>
            <ValueInflatable
              form={form.FromMin}
              label="From Min"
              onChange={onChangeValue}
              avail={avail}
              name="FromMin"
              color="delete"
              showInf={false}
              onError={(e) => myError("frommin", null, e)}

            />
            <ValueInflatable
              form={form.ToMax}
              label="To Max"
              onChange={onChangeValue}
              avail={avail}
              name="ToMax"
              color="delete"
              showInf={false}
              onError={(e) => myError("tomax", null, e)}

            />
            <FormControlLabel
              sx={{ mt: 2 }}
              control={
                <Checkbox
                  checked={form.SpousalKeepBalanced}
                  name="SpousalKeepBalanced"
                  onChange={onChange_c}
                />
              }
              label="Spousal: Keep Balanced"
            />
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
};

export const PenSlash = ({ changed, error }) => {
  return (
    <Box sx={{ mr: 1 }}>
      <span className="fa-layers">
        <FontAwesomeIcon
          color={error ? "#ff0000" : (changed ? "#228B22" : "#7fc3e5")}
          size="xs"
          icon={faPencil}
        />
        {(!changed) &&
          <FontAwesomeIcon
            color={myOwnFPColor}
            size="xs"
            icon={faSlash}
          />
        }
      </span>
    </Box>
  )
}

const ToAccountAccordion = ({
  avail,
  availSpouse,
  form,
  onChange,
  accountType,
  accountTypeSpecific,
  doValidation,
  onError,
}) => {
  const [error, setError] = useState(false)

  const myError = (e) => {
    setError(errorJsonHasErrors(e))
    onError(e)
  }

  return (
    // <Accordion sx={{ maxWidth: 800 }}>
    <Accordion >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <PenSlash
          changed={form.Changed}
          error={error}
        />
        <Stack spacing={2}>
          <Typography        >
            {form.TextRule}
            <br />
          </Typography>
          <Typography color="#228B22">
            {form.NewTextRule}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <ToAccount
          avail={avail}
          availSpouse={availSpouse}
          form={form}
          onChange={onChange}
          accountType={accountType}
          accountTypeSpecific={accountTypeSpecific}
          doValidation={doValidation}
          onError={myError}
        />
      </AccordionDetails>
    </Accordion>

  )
}

const FromAccount = ({
  avail,
  availSpouse,
  form,
  onChange,
  accountType,
  accountTypeSpecific,
  direction,
  label,
  none_allowed = false,
  doValidation,
  onError
}) => {

  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    console.log("VY:change");
    console.log(form);
    console.log(n);
    console.log(v);
    let nf = structuredClone(form);
    nf[n] = v;
    console.log(nf);
    onChange(nf);
    return nf
  };



  const onChange_list = (e) => {
    const value = e.target.value;
    const values = typeof value === "string" ? value.split(",") : value;
    console.log(values);
    let nf = onChange_any(e.target.name, values);
    validate(nf)
  };

  const nt_Change = (name, type) => {

    // console.log(name);
    // console.log(type);

    let nf = structuredClone(form);
    nf["AccountName"] = name;
    nf["AccountType"] = type;
    // console.log(nf);
    onChange(nf);
  };

  const validate = (f) => {
    // console.log("validate")
    // console.log(form)
    // console.log(f)
    // console.log(f.Who)
    let ne = structuredClone(errors)
    let err = (Arrayify(f.Who).length === 0) ? "Please select Who" : ""
    ne = set(ne, "Who", err)

    setErrors(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }

  }


  useEffect(() => {
    validate(form)
  }, [doValidation])

  const AccountList = () => {
    return CombinedAccountNameList(form.Who, avail, availSpouse, label)
  }


  return (
    <Container maxWidth="true">
      {/* <Container> */}

      <Box sx={{ mt: 1, p: 2, border: "1px solid grey" }}>
        <Typography sx={{ mt: -2 }} id="s-die-age-slider" variant="h6" gutterBottom={false}>
          {label + " Account"}
        </Typography>
        <Stack direction={direction} spacing={2}>
          <InputSelectN
            label="Who"
            name="Who"
            value={form.Who}
            onChange={onChange_list}
            errors={errors}
            avail={avail.Who}
            minWidth={180}
          />
          <InputAccountTypeName
            avail={AccountList()}
            inputForm={form}
            onChange={nt_Change}
            none_allowed={none_allowed ? true : false}
            onError={(e) => errorSetPlus(onError, errors, setErrors, "accounts", null, e)}
          />
        </Stack>
      </Box>
    </Container>
  );
};

const AddSavingRule = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  accountType,
  add,
  when,
  year,
  spouseFirst = false,
  no_from_allowed = false,
  copy = false,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [client, setClient] = useState(client_p);
  const [clients, setClients] = useState([client_p]);
  const [spouse, setSpouse] = useState("");
  const [added, setAdded] = useState([false, false]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [doValidation, setDoValidation] = useState(0)
  const [deleted, setDeleted] = useState(false)
  const [availSpouse, setAvailSpouse] = useState({})



  const getInputData = (client_, extraArg) => {
    let url = SavingRuleUrl_get(clientJson, "savingrule", when, year, add, extraArg);
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setAdded([false, false]);
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          Update(client_);
          console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const myClose = () => {
    data.current = null;
    setDataset(null);
    close(accountType);
  };

  const putRequest = async (extraArg) => {
    console.log(extraArg)
    let url = SavingRuleUrl_put(clientJson, "savingrule", when, year, extraArg);
    var req = putOptions;
    let post = CleanAvail(form)
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((json) => {
        console.log("update completed");
        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const onSubmit = () => {
    //validate(form)
    errorCheckForm()
    console.log(errors)
    if (!errorJsonHasErrors(errors)) {
      console.log("on submit");
      console.log(form);
      putRequest("");
    }
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      setDeleted(false)
      let extraArg = ""
      if (spouseFirst) {
        extraArg = "spouse=true"
      }
      if (copy) {
        if (extraArg !== "") {
          extraArg += "&"
        }
        extraArg += "copy=true"
      }
      getInputData(client_p, extraArg);
    }
  }, [show]);

  useEffect(() => {
    let cl = client === clients[0] ? 0 : 1;
    if (add && dataset && !added[cl]) {
      if (dataset.From && dataset.From.length === 0) {
        //onAddFrom();
        onAddTo();
      }
      let x = added;
      x[cl] = true;
      setAdded(x);
    }
  }, [add, dataset]);

  const Update = (cl) => {
    setClient(cl);
    setDataset(data.current.DataSet[cl]);

    setSpouse("")
    setAvailSpouse({})
    for (let c of data.current.Clients) {
      if (c !== cl) {
        setSpouse(c)
        setAvailSpouse(data.current.DataSet[c].Avail)
      }
    }
  };

  const anyChange = (subpath, any) => {
    console.log("any_change: ");
    console.log(any);
    let path = "DataSet[" + client + "]";
    if (subpath !== "") {
      path += "." + subpath;
    }

    console.log("Path: " + path);
    let nf = form;
    nf = set(nf, path, any);
    setForm(nf);
    nf = {
      ...nf,
    };
    setForm(nf);

    Update(client);
    console.log(nf);
  };

  const onChangeSub = (e, name, i) => {
    console.log("SA: " + name);
    console.log(e);
    console.log(i);

    let path = name + "[" + i + "]";
    if (name === "To") {
      e.NewTextRule = SavingRuleText(e, accountType === "Surplus" ? "Surplus*" : "Gross*", dataset.From, accountType === "Surplus" ? true : false, dataset.Avail.RegisteredAccountNames)
      e.Changed = true
      anyChange(path, e);
    } else {
      let nf = form;
      let pds = "DataSet[" + client + "]";
      nf = set(nf, pds + "." + path, e)
      let from2 = get(nf, pds + "." + name)
      console.log(from2)
      for (let tk in dataset.To) {
        let to = dataset.To[tk]
        let pto = pds + ".To[" + tk + "]"
        to.NewTextRule = SavingRuleText(to, accountType === "Surplus" ? "Surplus*" : "Gross*", from2, accountType === "Surplus" ? true : false, dataset.Avail.RegisteredAccountNames)
        to.Changed = true
        nf = set(nf, pto, to);
      }
      setForm(nf);
      nf = {
        ...nf,
      };
      setForm(nf);

      Update(client);
      // we should change them all when From changes
    }

    // let json = data.current.DataSet[client][name].slice();
    // json = json.filter((o) => o.length !== 0);
    // console.log(json);
    // anyChange(name, json);
  };

  const btnClientChanged = (cl) => {
    Update(cl);
  };

  const onChange_t = (e) => {
    anyChange(e.target.name, e.target.value);
  };

  const onAddFrom = (e, name) => {
    let n = structuredClone(from);
    let json = [];
    if (dataset.From) {
      json = dataset.From.slice();
      n.Id = Math.max(...dataset.From.map((o) => o.Id), 0) + 1;
    }
    json.push(n);
    console.log(json);
    anyChange("From", json);
  };
  const onDeleteFrom = (e, Id) => {
    let json = dataset.From.slice();
    json = json.filter((o) => o.Id !== Id);
    errorClear(errors)
    anyChange("From", json);
    setDeleted(true)

  };

  const onAddTo = (e) => {
    let n = structuredClone(to);
    let json = [];
    if (dataset.To) {
      json = dataset.To.slice();
      n.Id = Math.max(...dataset.To.map((o) => o.Id), 0) + 1;
    }
    json.push(n);
    console.log(json);
    anyChange("To", json);
  };
  const onDeleteTo = (e, Id) => {
    let json = dataset.To.slice();
    json = json.filter((o) => o.Id !== Id);
    errorClear(errors)
    anyChange("To", json);
    setDeleted(true)

  };
  const ToIncrease = (e, i) => {
    let json = dataset.To.slice();
    let t = json[i]
    json[i] = json[i - 1]
    json[i - 1] = t
    anyChange("To", json);
  }
  const ToDecrease = (e, i) => {
    let json = dataset.To.slice();
    let t = json[i]
    json[i] = json[i + 1]
    json[i + 1] = t
    anyChange("To", json);
  }

  const FromIncrease = (e, i) => {
    let json = dataset.From.slice();
    let t = json[i]
    json[i] = json[i - 1]
    json[i - 1] = t
    anyChange("From", json);
  }
  const FromDecrease = (e, i) => {
    let json = dataset.From.slice();
    let t = json[i]
    json[i] = json[i + 1]
    json[i + 1] = t
    anyChange("From", json);
  }

  const myError = (obj, i, err) => {
    errorSet(errors, setErrors, obj, i, err)
  }

  const copyAllRulesToSpouse = () => {
    errorCheckForm()
    console.log(errors)
    if (!errorJsonHasErrors(errors)) {
      console.log("on submit");
      console.log(form);
      putRequest("copyToSpouse=" + spouse);
    }


  }

  const spouseButtonCheck = () => {
    if (!(data !== null && dataset !== undefined && dataset !== null)) {
      return false
    }
    if (spouse === "") {
      return false
    }
    if (dataset.FromSpouse) {
      return false
    }

    if (dataset.SpouseUseSameRules) {
      return false
    }
    return true
  }

  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label={accountType + " Saving Rule"}
        accountType={accountType}
        onClientChange={btnClientChanged}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}
        extraButton={spouseButtonCheck() ? "Submit <<" + client + "'s>> rules and Copy rules to <<" + spouse + ">>" : null}
        extraButtonTooltip={"Submit this rule, and then while doing copy all rules to spouse, replacing all " + spouse + "'s rules"}
        onExtraButton={copyAllRulesToSpouse}

      >
        {data !== null && dataset !== undefined && dataset !== null && (

          <Stack >
            {/* <Stack direction="row" spacing={2}>
              <Input_Year
                year={dataset.Year}
                birthYear={dataset.BirthYear}
                onChange={onChange_t}
                onError={(e) => { setDoValidation(doValidation + 1); myError("year", 0, e) }}
              />
            </Stack> */}
            <Stack sx={{ mx: 4 }} spacing={2}>
              {spouse !== "" && (
                <Stack>
                  <Box sx={{ mt: 1, mb: 2, p: 1, border: "1px solid grey" }}>
                    <Stack sx={{}} direction="row" spacing={2}>
                      <InputCheck
                        value={dataset.FromSpouse}
                        label={"Use Rules From " + spouse}
                        disabled={true}
                      />
                      {!dataset.FromSpouse && (
                        <InputCheck
                          value={dataset.SpouseUseSameRules}
                          label={spouse + " uses all these Rules"}
                          name="SpouseUseSameRules"
                          onChange={(name, value) => anyChange(name, value)}
                        />
                      )}
                    </Stack>
                  </Box>
                </Stack>
              )}
              {!dataset.FromSpouse && (
                <>
                  <Stack sx={{}} direction="row" spacing={2}>
                    <InputYear
                      year={dataset.Year}
                      birthYear={dataset.BirthYear}
                      onChange={onChange_t}
                      onError={(e) => { setDoValidation(doValidation + 1); myError("year", null, e) }}
                    />
                    {accountType !== "Surplus" && (
                      <Typography id="s-die-age-slider" variant="h6" gutterBottom>
                        From Gross and
                      </Typography>
                    )}
                  </Stack>
                  <Stack direction="row" spacing={2}>
                    {accountType !== "Surplus" &&
                      dataset.From !== undefined &&
                      dataset.From !== null && (
                        <>
                          <Stack spacing={2}>

                            {Arrayify(dataset.From).length === 0 && (
                              <Stack sx={{ px: 4, py: 4 }}>
                                <CollapseAddLabel
                                  label="From"
                                  onClick={(e) => onAddFrom(e, "From")}
                                />
                              </Stack>
                            )}


                            {Arrayify(dataset.From).map((d, i) => (
                              <Stack
                                key={"ft-" + d.Id}
                                direction="row"
                                spacing={2}
                              >
                                <Stack sx={{ py: 4 }}>
                                  <CollapseAddLabel
                                    label="From"
                                    onClick={(e) => onAddFrom(e, "From")}
                                  />
                                </Stack>
                                <FromAccount
                                  avail={dataset.Avail}
                                  availSpouse={availSpouse}
                                  form={d}
                                  direction="row"
                                  label="From"
                                  onChange={(e) => onChangeSub(e, "From", i)}
                                  accountType={accountType}
                                  accountTypeSpecific={dataset.Type}
                                  none_allowed={no_from_allowed}
                                  doValidation={doValidation}
                                  onError={(e) => myError("fromacct", i, e)}

                                />
                                <Stack direction="row" spacing={2} sx={{ py: 4 }} >
                                  <Stack direction="row" spacing={2} sx={{ pr: 2 }} >
                                    {(i !== 0) && (
                                      <Up onClick={(e) => FromIncrease(e, i)} />
                                    )}
                                    {(i !== dataset.From.length - 1) && (
                                      <Down onClick={(e) => FromDecrease(e, i)} />
                                    )}
                                  </Stack>
                                  <CollapseDelete
                                    onClick={(e) => onDeleteFrom(e, d.Id)}
                                  />
                                </Stack>
                              </Stack>
                            ))}
                          </Stack>
                        </>
                      )}
                    <Stack sx={{ pl: 4, py: 4 }}>
                      <CollapseAddLabel
                        label="To"
                        onClick={onAddTo} />
                    </Stack>

                    {dataset.To !== undefined &&
                      dataset.To !== null && (
                        <>
                          <Stack spacing={2}>
                            {Arrayify(dataset.To).map((d, i) => (
                              <Stack key={"ft-" + d.Id} direction="row" spacing={2}>
                                <ToAccountAccordion
                                  avail={dataset.Avail}
                                  availSpouse={availSpouse}
                                  form={d}
                                  name="To"
                                  onChange={(e) => onChangeSub(e, "To", i)}
                                  accountType={accountType}
                                  accountTypeSpecific={dataset.Type}
                                  onError={(e) => myError("toacct", i, e)}

                                />
                                <Stack direction="row" spacing={2} sx={{ py: 4 }} >
                                  <Stack direction="row" spacing={2} sx={{ pr: 2 + (i === dataset.To.length - 1 ? 7 : 0), pl: (i === 0 ? 7 : 0) }} >
                                    {(i !== 0) && (
                                      <Up onClick={(e) => ToIncrease(e, i)} />
                                    )}
                                    {(i !== dataset.To.length - 1) && (
                                      <Down onClick={(e) => ToDecrease(e, i)} />
                                    )}
                                  </Stack>
                                  <CollapseDelete
                                    onClick={(e) => onDeleteTo(e, d.Id)}
                                  />
                                </Stack>
                              </Stack>
                            ))}
                          </Stack>
                        </>
                      )}
                  </Stack>
                </>
              )}
            </Stack>
          </Stack>
        )}

      </AddDialog >
    </>
  );
};

export default AddSavingRule;
